import { render, staticRenderFns } from "./add.vue?vue&type=template&id=769c551a&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=769c551a&prod&scoped=true&lang=css"
import style1 from "./add.vue?vue&type=style&index=1&id=769c551a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769c551a",
  null
  
)

export default component.exports